import { Text } from "@src/shared/components/general/Text";
import { Accordion } from "@src/shared/components/layout/Accordion/Accordion";
import {
  HorizontalFlexbox,
  VerticalFlexbox,
} from "@src/shared/components/layout/Flexbox";
import { Badge, type BadgeProps } from "@src/shared/components/ui/badge";

type BadgeIntent = NonNullable<BadgeProps["variant"]>;

const INTENT_MAP: Record<string, BadgeIntent> = {
  critical: "destructive",
  danger: "destructive",
  warning: "warning",
  info: "accent",
  success: "success",
  primary: "accent",
  none: "subtle",
};

interface BriefingAccordionProps {
  title: string;
  subtitle: string;
  badgeLabel?: string;
  badgeIntent?: string;
}

export const BriefingAccordion = ({
  title,
  subtitle,
  badgeLabel,
  badgeIntent = "critical",
  children,
}: React.PropsWithChildren<BriefingAccordionProps>) => {
  const variant = INTENT_MAP[badgeIntent] ?? "destructive";
  return (
    <Accordion
      header={
        <HorizontalFlexbox
          alignItems="center"
          justifyContent="space-between"
          gap="sm"
          className="flex-1"
        >
          <VerticalFlexbox>
            <Text sizing="md" fontWeight={500}>
              {title}
            </Text>
            <Text sizing="sm" appearance="subdued">
              {subtitle}
            </Text>
          </VerticalFlexbox>
          {badgeLabel ? <Badge variant={variant}>{badgeLabel}</Badge> : null}
        </HorizontalFlexbox>
      }
    >
      {children}
    </Accordion>
  );
};
